import * as React from 'react'
import { Form, Input, InputNumber, Modal } from 'antd'
import { FormInstance } from 'antd/lib/form'

import { TTModalProps } from '../shared/TTModalProps'
import { TTInputCurrency } from '../shared/TTInputCurrency'

interface ModalAmountProps extends TTModalProps {
    value: number,
}

//class ModalAmountState {
//    amount: number
//    variazioneEuro: number
//    variazionePerc: number
//}

export class ModalAmount extends React.Component<ModalAmountProps, any> {

    formRef = React.createRef<FormInstance>()
    inputRef = React.createRef<HTMLInputElement>()

    variazioneEuro: number
    variazionePerc: number

    constructor(props) {
        super(props)
        //let _state = new ModalAmountState()
        //this.state = _state

    }

    componentDidUpdate(prevProps: ModalAmountProps) {
        if (prevProps.visible == false && this.props.visible == true) {
            this.inputRef.current.focus()
            this.updateAmount(this.props.value)
        }

    }

    closeModal = () => {
        this.formRef.current.resetFields()
        this.props.closeModal()
    }

    onSave = async () => {
        try {
            let data = await this.formRef.current.validateFields()

            this.props.do(data.Amount)
            this.closeModal()
        } catch (err) {
            console.log(err)
        }
    }

    euroToPerc = (val: number) => {
        if (val == null || val == 0) return
        let amount =  this.props.value + val
        amount = Number(amount.toFixed(2))
        this.updateAmount(amount)
        if (this.props.value > 0) {
            let variazionePerc = (val * 100) / this.props.value
            variazionePerc = Number(variazionePerc.toFixed(2))
            this.updateVariazionePerc(variazionePerc)
        }
    }

    percToEuro = (val: number) => {
        if (val == null || val == 0) return
        let variazioneEuro = (val * this.props.value) / 100
        variazioneEuro = Number(variazioneEuro.toFixed(2))
        let tot = (this.props.value + variazioneEuro)
        let amout = Number(tot.toFixed(2))
        this.updateAmount(amout)
        this.updateVariazioneEuro(variazioneEuro)
    }

    updateAmount(value: number) {
        this.formRef.current.setFieldsValue({ Amount: value })
    }

    updateVariazioneEuro(value: number) {
        this.formRef.current.setFieldsValue({ VariazioneEuro: value })
    }

    updateVariazionePerc(value: number) {
        this.formRef.current.setFieldsValue({ VariazionePerc: value })
    }

    render() {
        return (

            <Modal
                destroyOnClose
                title="Inserisci l'incremento o il decremento"
                visible={this.props.visible}
                onCancel={this.closeModal}
                onOk={this.onSave}>
                <Form ref={this.formRef}>
                    <Form.Item
                        label="Importo"
                        name="Amount"
                        initialValue={this.props.value}
                         >
                        <TTInputCurrency style={{ width: '40%' }} disabled={true}  />
                    </Form.Item>
                    <Form.Item
                        label="Variazione (€)"
                        name="VariazioneEuro"
                    >
                        <TTInputCurrency style={{ width: '40%' }} ref={this.inputRef} onChange={e => this.euroToPerc(e as number)} />
                    </Form.Item>
                    <Form.Item
                        label="Variazione (%)"
                        name="VariazionePerc"
                        initialValue={(this.variazionePerc == null ? 0 : this.variazionePerc )}
                    >
                        <InputNumber style={{ width: '40%' }} onChange={e => this.percToEuro(e as number)} />
                    </Form.Item>
                </Form>
            </Modal>
        )
    }
}